import { render, staticRenderFns } from "./CompactInput.vue?vue&type=template&id=23707a7c&"
import script from "./CompactInput.vue?vue&type=script&lang=js&"
export * from "./CompactInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports